import {debounce, throttle} from '../../helpers';

export class DisplayText {
	constructor(game) {
		this.game = game;
		this.display = document.getElementById('score');
		this.text = this.display.querySelector('.score__text');
		this.basket = this.display.querySelector('.score__basket');
		this.point = this.display.querySelector('.score__point');
		this.lastScore = 0;
	}

	draw() {
		throttle(() => {
			this.text.innerHTML = `${this.game.score}<span>из</span>${this.game.maxScore}`;
			this.basketAnimation();
		})();

		// this.game.ctx.font = '40px Helvetica';
		// this.game.ctx.fillStyle = 'black';
		// this.game.ctx.fillText(`Score ${this.game.score}`, 50, 50);
	}

	basketAnimation() {
		if (this.lastScore < this.game.score) {
			this.basket.classList.add('is-open');

			setTimeout(() => {
				this.basket.classList.remove('is-open');
			}, 200);

			this.lastScore = this.game.score;
		}
	}

	pointAnimate(value) {
		this.point.textContent = `+${value}`;
		this.point.classList.add('is-vision');

		this.hidePoint();
	}

	hidePoint = debounce(() => {
		this.point.classList.remove('is-vision');
	}, 300);
}
